import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import { GENERATED_PDF_CLASIFICATION_TYPE } from "@Shared/utils/constants";
import { find, mapValues, orderBy, pick, reduce, values, parseInt } from "lodash";
export const DOCUMENTS_CLASSIFICATIONS_FOR_APPLICATION = "DOCUMENTS_CLASSIFICATIONS_FOR_APPLICATION";
export const DOCUMENTS_FOR_APPLICATION = "DOCUMENTS_FOR_APPLICATION";
export const COMMENTS_FOR_APPLICATION = "COMMENTS_FOR_APPLICATION";
export const GENERATED_PDF_CLASSIFICATION_ID = "GENERATED_PDF_CLASSIFICATION_ID";
export const MARKED_DOCUMENT_CLASSIFICATIONS = "MARKED_DOCUMENT_CLASSIFICATIONS";
export const DOCUMENT_TYPES_SELECT = "DOCUMENT_TYPES_SELECT";
export const DOCUMENT_TYPE_DESCRIPTION = "DOCUMENT_TYPE_DESCRIPTION";
export const DOCUMENT_LABELS = "DOCUMENT_LABELS";
export const USER_DOCUMENT_LABELS = "USER_DOCUMENT_LABELS";
export const BROKERAGE_DOCUMENT_LABELS = "BROKERAGE_DOCUMENT_LABELS";
export const DOCUMENT_TYPES_DATA = "DOCUMENT_TYPES_DATA";
export const TOTAL_DOCUMENT_NEW_COMMENTS_BY_CLASSIFICATION = "TOTAL_DOCUMENT_NEW_COMMENTS_BY_CLASSIFICATION";
const getters = {
  [DOCUMENTS_CLASSIFICATIONS_FOR_APPLICATION]: state => applicationId => {
    return state.classifications.byApplication[applicationId] || {
      byId: {},
      allIds: []
    };
  },
  [DOCUMENTS_FOR_APPLICATION]: state => applicationId => {
    return state.documents.byApplication[applicationId] || {
      byId: {}
    };
  },
  [COMMENTS_FOR_APPLICATION]: state => applicationId => {
    return state.comments.byApplication[applicationId] || {
      byId: {}
    };
  },
  [GENERATED_PDF_CLASSIFICATION_ID]: state => applicationId => {
    var _find;
    const documentClassifications = state.classifications.byApplication[applicationId].byId;
    const {
      documentRequestId
    } = (_find = find(documentClassifications, ["classification", GENERATED_PDF_CLASIFICATION_TYPE()])) != null ? _find : {};
    return documentRequestId != null ? documentRequestId : "";
  },
  [MARKED_DOCUMENT_CLASSIFICATIONS]: state => applicationId => {
    return reduce(state.markedDocumentClassifications, (acc, value, key) => {
      if (state.classifications.byApplication[applicationId].byId[key] && value) acc.push(key);
      return acc;
    }, []);
  },
  [DOCUMENT_TYPES_SELECT]: state => {
    const documentTypes = values(mapValues(state.documentTypes.byId, value => pick(value, ["title", "documentTypeId", "typeOrder"])));
    return orderBy(documentTypes, ({
      typeOrder
    }) => parseInt(typeOrder), ["asc"]);
  },
  [DOCUMENT_TYPE_DESCRIPTION]: state => documentTypeId => {
    return state.documentTypes.byId[documentTypeId].description || "";
  },
  [DOCUMENT_LABELS]: state => ({
    applicationId,
    documentId
  }) => {
    var _state$documents$byAp;
    return ((_state$documents$byAp = state.documents.byApplication[applicationId].byId[documentId]) == null ? void 0 : _state$documents$byAp.labels) || [];
  },
  [USER_DOCUMENT_LABELS]: state => {
    var _state$labels$userLab;
    return values((_state$labels$userLab = state.labels.userLabels) == null ? void 0 : _state$labels$userLab.byId);
  },
  [BROKERAGE_DOCUMENT_LABELS]: state => {
    var _state$labels$brokera;
    return values((_state$labels$brokera = state.labels.brokerageLabels) == null ? void 0 : _state$labels$brokera.byId);
  },
  [DOCUMENT_TYPES_DATA]: state => {
    return _Object$values(state.documentTypes.byId);
  },
  [TOTAL_DOCUMENT_NEW_COMMENTS_BY_CLASSIFICATION]: state => ({
    applicationId,
    classificationId
  }) => {
    var _state$classification, _state$classification2, _state$classification3;
    const documentsId = (_state$classification = (_state$classification2 = state.classifications.byApplication[applicationId]) == null ? void 0 : (_state$classification3 = _state$classification2.byId[classificationId]) == null ? void 0 : _state$classification3.documents) != null ? _state$classification : null;
    if (!documentsId) return 0;
    return _reduceInstanceProperty(documentsId).call(documentsId, (acc, id) => {
      var _state$documents$byAp2, _state$documents$byAp3, _state$documents$byAp4;
      const newCommentsCount = (_state$documents$byAp2 = (_state$documents$byAp3 = state.documents.byApplication[applicationId]) == null ? void 0 : (_state$documents$byAp4 = _state$documents$byAp3.byId[id]) == null ? void 0 : _state$documents$byAp4.nrOfNewComments) != null ? _state$documents$byAp2 : 0;
      return acc + newCommentsCount;
    }, 0);
  }
};
export default getters;